export default __webpack_public_path__ + "static/media/value-reuse.8c31dc9d.svg";